import type { Product } from '#bv/data/products'
import { bundleFromPriceUsd } from '#bv/lib/productCatalog'

const SITE_ORIGIN = 'https://blkvault.cc'

export function productPageUrl(productId: number): string {
  return `${SITE_ORIGIN}/products/${productId}`
}

export function productJsonLdScript(product: Product, inStock: boolean): Record<string, unknown> {
  const price = bundleFromPriceUsd(product) ?? product.price

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description: (product.shortDescription || product.description).slice(0, 500),
    image: product.image.startsWith('http') ? product.image : `${SITE_ORIGIN}${product.image}`,
    offers: {
      '@type': 'Offer',
      url: productPageUrl(product.id),
      priceCurrency: 'USD',
      price: price.toFixed(2),
      availability: inStock ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
    },
  }
}
